import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';
import { PrBuyerHelperService } from 'src/app/modules/pr-buyer/services/pr-buyer-helper.service';
import { RfqService } from 'src/app/modules/pr-buyer/services/rfq/rfq.service';
import { PrInitiatorService } from 'src/app/modules/pr-initiator/services/pr-initiator.service';
import { qesService } from '../../../services/qes/qes.service';
interface FileSize {
  file : File,
  formatSize : string
}

@Component({
  selector: 'app-qes-upload-attachment',
  templateUrl: './qes-upload-attachment.component.html',
  styleUrls: ['./qes-upload-attachment.component.scss']
})
export class QesUploadAttachmentComponent implements OnInit {

  public prFiles : Array<any> = [];
  private _qesNo: any | undefined | null;
  public upload_remarks: any;
  public onClose!: Subject<any>;
  public onClosePrAttachment = new BehaviorSubject<any>({});
  public isPrAttachments!: any;
  public prFilesList!: any;
  public rfqFileList!: any;
  public viewRFQFiles!:boolean;
  @Input() isRfqAttachments !: boolean;
  @Input() uploadedFiles !: Array<any>;
  @Output() rfqFiles : EventEmitter<any> = new EventEmitter<any>();
  constructor(public bsModalRef: BsModalRef,
    private _helperService: PrBuyerHelperService,
    private _toastrService: ToastrService,
    private _qesService: qesService,
    private _rfqService: RfqService,
    private _prInitiaterService: PrInitiatorService) {
      console.log("prFilesList", this.prFilesList)
     }

  ngOnInit(): void {
    this.onClose = new Subject();
    this._qesService.getqesNoSub().subscribe((_qesNo: any) => {
      this._qesNo = _qesNo;
    });
    this.prFiles = this.prFilesList?.length ? this.prFilesList: this.uploadedFiles?this.uploadedFiles:[];
  }

  public onModalClose(): void {
    if(!this.isPrAttachments){
      this.onClose.next(true);
    } else{
      this.onClose.next(this.prFiles);
    }
    this.bsModalRef.hide();
  }

   public formatFileSize = (bytes : any, decimals = 2) : string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  // Helper method to calculate current total file size
  private calculateCurrentTotalSize(): number {
    return this.prFiles.reduce((total, fileObj) => total + fileObj.file.size, 0);
  }

  public verifyFile(event: any): void {
    const maxSizeInBytes = 20 * 1024 * 1024; // 20MB in bytes
    let currentTotalSize = this.calculateCurrentTotalSize();
    
    [...event.target.files].forEach((file: File) => {      
      // Check if adding this file would exceed total size limit
      if (currentTotalSize + file.size > maxSizeInBytes) {
        alert(`Cannot add "${file.name}". Total file size would exceed 20MB limit. Current total: ${this.formatFileSize(currentTotalSize)}`);
        return;
      }
      
      // Check for duplicate files
      const isDuplicate = this.prFiles.some(existingFile => 
        existingFile.file.name === file.name && existingFile.file.size === file.size
      );
      
      if (isDuplicate) {
        alert(`File "${file.name}" is already added.`);
        return;
      }
      
      // Add file if all validations pass
      this.prFiles.push({ file, formatSize: this.formatFileSize(file.size) });
      currentTotalSize += file.size;
    });

    // Clear the input to allow selecting the same file again if needed
    event.target.value = '';
    
    console.log(`Total files: ${this.prFiles.length}, Total size: ${this.formatFileSize(this.calculateCurrentTotalSize())}`);
    this.isRfqAttachments?this.rfqFiles.emit(this.prFiles):'';
  }

  public clearFile(i:any): void {
    this.prFiles.splice(i,1);
  }

  public UploadAttachment(): void {
    const formData = new FormData();
    for (var i = 0; i < this.prFiles.length; i++) {
      formData.append("file", this.prFiles[i].file);
    }
    if(!this.isPrAttachments && !this.isRfqAttachments){
      this._qesService.uploadQesAttachmnet(this._qesNo?.id, this.upload_remarks, formData).subscribe((res: any) => {
        this._toastrService.success(res.message);
        this.onModalClose();
      }, err => {
        this._toastrService.error(err.error.message);
      });
    } else {
      this._toastrService.success("Files are Uploaded Successfully!");
      this.isRfqAttachments?this.rfqFiles.emit(this.prFiles):'';
      this.onModalClose();
    }
  }

  public downloadRFQfile(file:any){
    this._rfqService.downloadRFQTemplateAttachment(file.id).subscribe((res : any) => {
      this._helperService.saveFileData(res, file.name);
    });
  }

}
